module.exports = __webpack_public_path__ + "img/ensure-diabetes.b31a2011.jpg";